// extracted by mini-css-extract-plugin
module.exports = {"container":"app_container__3FwrV","loadingOverlay":"app_loadingOverlay__3Ndx7","body":"app_body__23jZ8"};